<section class="banner" *ngIf="pageData.carousel && !useAlternateBanner">
  <app-carousel
    *ngIf="pageData.carousel"
    [carousel]="pageData.carousel"
    [cardStyle]="cardStyle"
  ></app-carousel>
</section>

<section class="banner" *ngIf="pageData.carousel_alt && useAlternateBanner">
  <app-carousel
    *ngIf="pageData.carousel_alt"
    [carousel]="pageData.carousel_alt"
    [cardStyle]="cardStyle"
  ></app-carousel>
</section>
